module.exports = __webpack_public_path__ + "static/media/PPO-AE2.f8c9a4c6.pdf";